import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['picker']

  connect () {
    this.longPressTimer = null
    this._closeOnOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.hidePicker()
    }
    document.addEventListener('click', this._closeOnOutsideClick)
  }

  disconnect () {
    this.clearLongPress()
    document.removeEventListener('click', this._closeOnOutsideClick)
  }

  pressStart () {
    this.clearLongPress()
    this.longPressTimer = window.setTimeout(() => {
      this.showPicker()
    }, 350)
  }

  pressEnd () {
    this.clearLongPress()
  }

  togglePicker (event) {
    event.preventDefault()
    if (!this.hasPickerTarget) return

    this.pickerTarget.classList.contains('hidden') ? this.showPicker() : this.hidePicker()
  }

  showPicker () {
    if (!this.hasPickerTarget) return
    this.pickerTarget.classList.remove('hidden')
  }

  hidePicker () {
    if (!this.hasPickerTarget) return
    this.pickerTarget.classList.add('hidden')
  }

  clearLongPress () {
    if (!this.longPressTimer) return
    window.clearTimeout(this.longPressTimer)
    this.longPressTimer = null
  }
}
